import * as React from 'react'
import * as cn from 'classnames'
import { LocalizerProps, withLocalization } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import * as st from './watchPartyLink.module.scss'
import { ActionForm } from '../../utils/actionForm'


export interface WatchPartyLinkProps {
  watchPartyAction: WpsRuntime.atv.wps.WatchPartyActionProps
  buttonClassName?: string
}

type LocalizedWatchPartyLinkProps = WatchPartyLinkProps & LocalizerProps
export const LocalizedWatchPartyLink = ({ watchPartyAction, buttonClassName, getString }: LocalizedWatchPartyLinkProps) => {
  const { endpoint: { partialURL, query } } = watchPartyAction
  return (
    <ActionForm action={partialURL} method={'POST'} hiddenInputs={query}>
      <button className={cn(st.submit, buttonClassName)}>{getString(StringId.DV_DP_CREATE_WATCH_PARTY)}</button>
    </ActionForm>
  )
}

export const WatchPartyLink = withLocalization(LocalizedWatchPartyLink)
